/* eslint-disable max-statements */
import axios from 'axios';
import React, { useState } from 'react';
import { FaEye, FaEyeSlash } from 'react-icons/fa';
import { QueryClient, QueryClientProvider, useMutation } from 'react-query';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';

import validator from 'validator';
import { LoginAuthAction } from '../redux/actions/authAction';
import SocialLoginComponent from '../components/Utils/LoginSSO/socialLogin';
import { globalEnv } from '../config/baseConfig';

const queryClient = new QueryClient();

export default function Login() {
	return (
		<QueryClientProvider client={queryClient}>
			<LoginBody />
		</QueryClientProvider>
	);
}

function LoginBody() {
	const [showPassword, setshowPassword] = useState(false);
	const [inputEmail, setinputEmail] = useState('');
	const [inputEmailTouched, setinputEmailTouched] = useState(false);
	const [inputPassword, setinputPassword] = useState('');
	const [inputPasswordTouched, setinputPasswordTouched] = useState(false);

	const stateAuth = useSelector((state: any) => state.auth);

	const dispatch = useDispatch();

	const [emailErrorMsg, setemailErrorMsg] = useState({
		message: '',
		error: false
	});
	const [passwordErrorMsg, setpasswordErrorMsg] = useState({
		message: '',
		error: false
	});

	const [isLoading, setIsLoading] = useState<boolean>(false);

	const loginReq = async () => {
		const params = new URLSearchParams();
		params.append('email', inputEmail);
		params.append('password', inputPassword);
		params.append('deviceId', '000000');
		return await axios
			.post(globalEnv.BASE_URL + '/user/login-editor/', params)
			.catch(function (error) {
				setIsLoading(false);
				if (error.response.data.message == 'Wrong password.') {
					setpasswordErrorMsg({ message: 'Wrong password.', error: true });
				} else
					setemailErrorMsg({
						message: 'No account with such email exists',
						error: true
					});
				throw new Error(error.response);
			});
	};

	const navigate = useNavigate();

	const loginSubmit = useMutation(loginReq, {
		onSuccess: (res) => {
			dispatch(LoginAuthAction(res.data));
			navigate(`../home/documents`);
		}
	});

	const verifEmailFormat = (email = '') => {
		if (validator.isEmpty(email, { ignore_whitespace: true })) {
			setemailErrorMsg({
				error: true,
				message: 'Please enter your email address'
			});
		} else {
			if (!validator.isEmail(email)) {
				setemailErrorMsg({
					error: true,
					message: 'Email must be a valid format'
				});
			} else if (email.indexOf(' ') >= 0) {
				setemailErrorMsg({
					error: true,
					message: 'Email must not contain white spaces'
				});
			} else {
				setemailErrorMsg({ error: false, message: '' });
			}
		}
	};

	const verifPasswordFormat = (password = '') => {
		if (validator.isEmpty(password, { ignore_whitespace: true })) {
			setpasswordErrorMsg({ error: true, message: 'Please enter a password' });
		} else {
			if (password.length < 5) {
				setpasswordErrorMsg({
					error: true,
					message: 'Please enter a password longer than 5 characters'
				});
			} else if (password.length > 32) {
				setpasswordErrorMsg({
					error: true,
					message: 'Please enter a password shorter than 32 characters'
				});
			} else {
				setpasswordErrorMsg({ error: false, message: '' });
			}
		}
	};

	return (
		<div>
			<div
				className="absolute w-full h-full"
				style={{
					filter: 'blur(6px)',
					backgroundRepeat: 'no-repeat',
					backgroundSize: 'cover',
					backgroundImage: `url('https://images.unsplash.com/photo-1499336315816-097655dcfbda?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=crop&w=2710&q=80')`
				}}
			/>
			<div className="absolute w-full h-screen bg-black opacity-50" />

			<figure className="absolute h-screen flex z-0 top-0 left-0 right-0">
				<div className="w-full max-w-md m-auto bg-gray-900 rounded-xl border border-gray-600 shadow-default pt-10 pb-5 px-1">
					<blockquote className="text-2xl font-medium text-center">
						<p className="text-lg font-semibold">Meavana Editor Portal</p>
					</blockquote>

					<div className="text-primary m-6">
						<div className="flex items-center mt-3 justify-center">
							<h1 className="text-2xl font-medium text-primary mt-4 mb-2">
								Login to your account
							</h1>
						</div>
						<div>
							<label className="text-left">Email</label>
							<input
								name="email"
								type="text"
								value={inputEmail}
								// onChange={handleChange}
								placeholder="Email"
								className="h-12 w-full border mt-2 rounded-lg outline-none p-2 placeholder-gray-500 text-black font-semibold"
								onBlur={() => {
									verifEmailFormat(inputEmail);
								}}
								onFocus={() => {
									setemailErrorMsg({ error: false, message: '' });
								}}
								onChange={(event) => {
									setinputEmail(event.target.value);
									setinputEmailTouched(true);
								}}
							/>
							{emailErrorMsg.error ? (
								<p className="text-red-500 text-xs italic text-right ml-auto h-4">
									{emailErrorMsg.message}
								</p>
							) : (
								<div className="mb-4" />
							)}

							<label className="mt-5">Password</label>

							<div className="container-input-icon-auth">
								<div className="relative">
									<input
										className="h-12 w-full border mt-2 rounded-lg outline-none p-2 placeholder-gray-500 text-black  font-semibold"
										type={showPassword ? 'text' : 'password'}
										placeholder="Password"
										onBlur={() => {
											verifPasswordFormat(inputPassword);
										}}
										onFocus={() => {
											setpasswordErrorMsg({ error: false, message: '' });
										}}
										onChange={(event) => {
											setinputPassword(event.target.value);
											setinputPasswordTouched(true);
										}}
									/>{' '}
									{showPassword ? (
										<FaEye
											className=" absolute top-6 right-3 cursor-pointer"
											onClick={() => {
												setshowPassword(false);
											}}
										/>
									) : (
										<FaEyeSlash
											className=" absolute top-6 right-3 cursor-pointer"
											onClick={() => {
												setshowPassword(true);
											}}
										/>
									)}
									{passwordErrorMsg.error ? (
										<p className="text-red-500 text-xs italic text-right ml-auto h-4">
											{passwordErrorMsg.message}
										</p>
									) : (
										<div className="mb-7" />
									)}
								</div>
							</div>
							{stateAuth.error ? (
								<div className="bg-indigo-900 text-center py-4 lg:px-4">
									<div
										className="p-2 bg-indigo-800 items-center text-indigo-100 leading-none lg:rounded-full flex lg:inline-flex"
										role="alert"
									>
										<span className="flex rounded-full bg-indigo-500 uppercase px-2 py-1 text-xs font-bold mr-3">
											Error
										</span>
										<span className="font-semibold mr-2 text-left flex-auto">
											{stateAuth.error.message}
										</span>
										<svg
											className="fill-current opacity-75 h-4 w-4"
											xmlns="http://www.w3.org/2000/svg"
											viewBox="0 0 20 20"
										>
											<path d="M12.95 10.707l.707-.707L8 4.343 6.586 5.757 10.828 10l-4.242 4.243L8 15.657l4.95-4.95z" />
										</svg>
									</div>
								</div>
							) : null}
							<div className="flex items-center flex-col mt-3 justify-center">
								{isLoading ? (
									<div className="mt-2">
										<svg
											role="status"
											className="w-8 h-8 text-gray-200 animate-spin dark:text-gray-600 fill-purple-700"
											viewBox="0 0 100 101"
											fill="none"
											xmlns="http://www.w3.org/2000/svg"
										>
											<path
												d="M100 50.5908C100 78.2051 77.6142 100.591 50 100.591C22.3858 100.591 0 78.2051 0 50.5908C0 22.9766 22.3858 0.59082 50 0.59082C77.6142 0.59082 100 22.9766 100 50.5908ZM9.08144 50.5908C9.08144 73.1895 27.4013 91.5094 50 91.5094C72.5987 91.5094 90.9186 73.1895 90.9186 50.5908C90.9186 27.9921 72.5987 9.67226 50 9.67226C27.4013 9.67226 9.08144 27.9921 9.08144 50.5908Z"
												fill="currentColor"
											></path>
											<path
												d="M93.9676 39.0409C96.393 38.4038 97.8624 35.9116 97.0079 33.5539C95.2932 28.8227 92.871 24.3692 89.8167 20.348C85.8452 15.1192 80.8826 10.7238 75.2124 7.41289C69.5422 4.10194 63.2754 1.94025 56.7698 1.05124C51.7666 0.367541 46.6976 0.446843 41.7345 1.27873C39.2613 1.69328 37.813 4.19778 38.4501 6.62326C39.0873 9.04874 41.5694 10.4717 44.0505 10.1071C47.8511 9.54855 51.7191 9.52689 55.5402 10.0491C60.8642 10.7766 65.9928 12.5457 70.6331 15.2552C75.2735 17.9648 79.3347 21.5619 82.5849 25.841C84.9175 28.9121 86.7997 32.2913 88.1811 35.8758C89.083 38.2158 91.5421 39.6781 93.9676 39.0409Z"
												fill="currentFill"
											></path>
										</svg>
									</div>
								) : (
									<button
										className="btn btn-outline btn-sm btn-primary mt-2"
										value="Login"
										disabled={
											stateAuth.loading ||
											!inputEmailTouched ||
											!inputPasswordTouched
										}
										onClick={() => {
											setIsLoading(true);
											loginSubmit.mutate();
										}}
									>
										Login
									</button>
								)}

								<div className="mt-5">
									<SocialLoginComponent
										isLoading={isLoading}
										setIsLoading={setIsLoading}
									/>
								</div>
							</div>
						</div>
					</div>
				</div>
			</figure>
		</div>
	);
}
